export function createDateFilterTemplate() {
    return (container) => createEasyDateFilterTemplate(container);
}
export function createDateTimeFilterTemplate() {
    return (container) => createEasyDateFilterTemplate(container);
}
export function createEasyDateFilterTemplate(container) {
    const options = [
        { text: TextResources.Views_Alle, value: "all" },
        { text: TextResources.Views_Heute, value: "today" },
        { text: TextResources.Views_ThisMonth, value: "thisMonth" },
        { text: TextResources.Views_LastMonth, value: "lastMonth" },
        { text: TextResources.Views_ThisYear, value: "thisYear" },
        { text: TextResources.Views_LastYear, value: "lastYear" },
        { text: TextResources.Views_Custom, value: "custom", disabled: true }
    ];
    const grid = container.element.closest("[data-role='grid']").data("kendoGrid");
    const filterCell = container.element.parents(".k-filtercell");
    const dataField = filterCell.data("field");
    filterCell.empty();
    filterCell.html(`<input id='customFilter_${dataField}'/>`);
    $(`#customFilter_${dataField}`, filterCell).kendoDropDownList({
        dataTextField: "text",
        dataValueField: "value",
        dataSource: options,
        autoWidth: true,
        change: (e) => {
            const selected = e.sender.value();
            const newFilter = getDateFilter(selected, dataField);
            const currentFilter = grid.dataSource.filter();
            const otherFilters = ((currentFilter === null || currentFilter === void 0 ? void 0 : currentFilter.filters) || []).filter((f) => f.field !== dataField);
            const combinedFilter = {
                logic: "and",
                filters: [...otherFilters, ...newFilter.filters]
            };
            grid.dataSource.filter(combinedFilter);
        },
        select: (e) => {
            if (e.dataItem.disabled) {
                e.preventDefault();
            }
        }
    });
    grid.bind("filter", (e) => {
        updateDateTimeFilterDropdownValue(e, dataField);
    });
    setTimeout(() => {
        grid.one("dataBound", (e) => {
            updateDateTimeFilterDropdownValue(e, dataField);
        });
    }, 0);
}
export function updateDateTimeFilterDropdownValue(e, dataField) {
    var _a, _b;
    const grid = e.sender;
    const ddlInput = $(e.sender.element).find(`.k-filtercell[data-field="${dataField}"] .k-dropdownlist input[data-role="dropdownlist"]`);
    const ddl = ddlInput.data("kendoDropDownList");
    if (ddl) {
        const filterList = ((_a = e.filter) === null || _a === void 0 ? void 0 : _a.filters) || ((_b = grid.dataSource.filter()) === null || _b === void 0 ? void 0 : _b.filters) || [];
        const dateFilter = filterList.filter((f) => f.field === dataField);
        const selectedKey = getKeyFromDateFilter(dateFilter);
        if (selectedKey) {
            ddl.value(selectedKey);
        }
    }
}
export function getDateFilter(key, field) {
    const today = new Date();
    let from;
    let to;
    switch (key) {
        case "today":
            from = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);
            to = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
            break;
        case "thisMonth":
            from = new Date(today.getFullYear(), today.getMonth(), 0);
            to = new Date(today.getFullYear(), today.getMonth() + 1, 1);
            break;
        case "lastMonth":
            from = new Date(today.getFullYear(), today.getMonth() - 1, 0);
            to = new Date(today.getFullYear(), today.getMonth(), 1);
            break;
        case "thisYear":
            from = new Date(today.getFullYear(), 0, 0);
            to = new Date(today.getFullYear() + 1, 0, 1);
            break;
        case "lastYear":
            from = new Date(today.getFullYear() - 1, 0, 1);
            to = new Date(today.getFullYear(), 0, 1);
            break;
        default:
            return { logic: "and", filters: [] };
    }
    return {
        logic: "and",
        filters: [
            { field, operator: "gt", value: from },
            { field, operator: "lt", value: to }
        ]
    };
}
export function getKeyFromDateFilter(filter) {
    if (!filter || !Array.isArray(filter) || filter.length === 0) {
        return "all";
    }
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    let from = null;
    let to = null;
    for (let i = 0; i < filter.length; i++) {
        const f = filter[i];
        if (f.operator === "gt") {
            from = new Date(f.value);
        }
        if (f.operator === "lt") {
            to = new Date(f.value);
        }
    }
    const isSameDate = (a, b) => (a === null || a === void 0 ? void 0 : a.getTime()) === (b === null || b === void 0 ? void 0 : b.getTime());
    const todayRangeStart = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);
    const todayRangeEnd = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
    if (isSameDate(from, todayRangeStart) && isSameDate(to, todayRangeEnd))
        return "today";
    const monthStart = new Date(today.getFullYear(), today.getMonth(), 0);
    const monthEnd = new Date(today.getFullYear(), today.getMonth() + 1, 1);
    if (isSameDate(from, monthStart) && isSameDate(to, monthEnd))
        return "thisMonth";
    const lastMonthStart = new Date(today.getFullYear(), today.getMonth() - 1, 0);
    const lastMonthEnd = new Date(today.getFullYear(), today.getMonth(), 1);
    if (isSameDate(from, lastMonthStart) && isSameDate(to, lastMonthEnd))
        return "lastMonth";
    const yearStart = new Date(today.getFullYear(), 0, 0);
    const yearEnd = new Date(today.getFullYear() + 1, 0, 1);
    if (isSameDate(from, yearStart) && isSameDate(to, yearEnd))
        return "thisYear";
    const lastYearStart = new Date(today.getFullYear() - 1, 0, 1);
    const lastYearEnd = new Date(today.getFullYear(), 0, 1);
    if (isSameDate(from, lastYearStart) && isSameDate(to, lastYearEnd))
        return "lastYear";
    return "custom";
}
export function createBoolFilterTemplate(trueString = null, falseString = null) {
    let resultingTrueString;
    let resultingFalseString;
    if (!trueString) {
        resultingTrueString = TextResources.Views_Ja;
    }
    else {
        resultingTrueString = trueString;
    }
    if (!falseString) {
        resultingFalseString = TextResources.Views_Nein;
    }
    else {
        resultingFalseString = falseString;
    }
    return (container) => container.element.kendoDropDownList({
        valuePrimitive: true,
        autoWidth: true,
        dataSource: {
            data: [
                { text: resultingTrueString, value: true },
                { text: resultingFalseString, value: false }
            ]
        },
        dataTextField: "text",
        dataValueField: "value",
        optionLabel: TextResources.Views_Alle
    });
}
export function createNumericFilterTemplate(min = null, max = null) {
    return (container) => container.element.kendoNumericTextBox({ min, max });
}
export function createLiveUpdateNumericFilterTemplate(decimals, min = null, max = null) {
    return (container) => {
        container.element.keyup((e) => {
            setTimeout(() => {
                let liveFilter = true;
                if (min && max) {
                    const val = $(e.target).val();
                    if (!Number.isNaN(parseFloat(val))) {
                        if (val < min || val > max) {
                            liveFilter = false;
                        }
                    }
                }
                if (e.key !== "." && liveFilter) {
                    $(e.target).data().kendoNumericTextBox.value($(e.target).val()); // Apply value to textbox before triggering change
                    $(e.target).data().kendoNumericTextBox.trigger("change");
                }
            }, 200);
        });
        container.element.kendoNumericTextBox({
            min,
            max,
            decimals,
            round: false,
            format: "n2",
            spin: (e) => {
                setTimeout(() => {
                    e.sender.element.data().kendoNumericTextBox.trigger("change");
                }, 200);
            }
        });
    };
}
export function createLiveUpdateTextFilterTemplate() {
    return (container) => {
        container.element.parent().addClass("k-widget k-autocomplete k-header k-state-default");
        container.element.addClass("k-input");
        container.element.keyup((e) => {
            setTimeout(() => {
                $(e.target).trigger("change");
            }, 200);
        });
    };
}
export function createAutoCompleteTextFilterTemplate(textField, filter) {
    return (container) => container.element.kendoAutoComplete({
        autoWidth: true,
        clearButton: false,
        dataSource: container.dataSource,
        dataTextField: textField,
        filter,
        valuePrimitive: true
    });
}
export function createStaticDropDownFilterTemplate(dataSerialized) {
    return (container) => container.element.kendoDropDownList({
        autoWidth: true,
        filter: "contains",
        dataSource: { data: dataSerialized },
        optionLabel: TextResources.Views_Alle
    });
}
export function createDynamicDropDownFilterTemplate(action) {
    return (container) => container.element.kendoDropDownList({
        autoWidth: true,
        autoBind: false,
        filter: "contains",
        dataSource: { transport: { read: action } },
        optionLabel: TextResources.Views_Alle
    });
}
